import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';

import type { Employee } from '../employee/employee';
import { EboNameObject } from './ebo-name-object';

export class EboNameObjectTO extends EboNameObject {
  modifiedOn: Dayjs;
  modifiedBy?: Employee;
  modifiedById: string;
  modifiedViaId: string;

  constructor(jsonData?: Partial<EboNameObjectTO>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.modifiedBy) {
        // Lazy import to avoid circular dependency
        const { Employee } = require('../employee/employee');
        this.modifiedBy = new Employee(jsonData.modifiedBy);
      }
      if (jsonData.modifiedOn) this.modifiedOn = SDate.newUtc(jsonData.modifiedOn);
    }
  }
}
